export default __webpack_public_path__ + "static/thumbnail-engie-ef1890928c74750651184b15bebad233.png";